import { render, staticRenderFns } from "./comment-optimiser-vos-campagnes-google-ads-pour-un-retour-sur-investissement-maximal.vue?vue&type=template&id=4b71ee34&"
import script from "./comment-optimiser-vos-campagnes-google-ads-pour-un-retour-sur-investissement-maximal.vue?vue&type=script&lang=js&"
export * from "./comment-optimiser-vos-campagnes-google-ads-pour-un-retour-sur-investissement-maximal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports